module.exports = __webpack_public_path__ + "img/combinedshapecopy2.95a288dd.svg";